import React from "react";
import I18n from "i18n-js";
import { func, shape } from "prop-types";

import Select from "../../../../common/components/form/Select";

import ClientUtils from "../../../../company/utils/ClientUtils";
import { SET_CLIENT, smallLabelFormInputProps } from "../constants";
import NoData from "../../../../common/components/elements/NoData";

InstallationEditFormClientSection.propTypes = {
  state: shape(),
  dispatch: func,
  errors: shape(),
};

export default function InstallationEditFormClientSection({
  state,
  dispatch,
  errors,
}) {
  return (
    <>
      <div className="detail-header">
        <div>{I18n.t("pages.installations.view.client:header")}</div>
        <div className="detail-header-band"></div>
      </div>
      <Select
        id="client"
        onChange={(event) =>
          dispatch({ type: SET_CLIENT, payload: event.target.value })
        }
        label={I18n.t("pages.installations.view.client:label")}
        renderOption={(option) => (
          <option key={option.uuid} value={option.uuid}>
            {ClientUtils.renderLabel(option)}
          </option>
        )}
        defaultValue={state.client}
        options={state.clientsOptions}
        placeholder={I18n.t(
          "pages.plannedInterventions.create.form.client:placeholder"
        )}
        error={errors.client}
        {...smallLabelFormInputProps}
      />
      {state.clientInfos ? (
        <dl className="row align-center">
          <dt className="col-sm-3">
            {I18n.t("pages.installations.view.attestation-number:label")}
          </dt>
          <dd className="col-sm-9">
            {state.clientInfos.certificateOfProfessionalCompetence?.number ??
              <NoData />}
          </dd>
          <dt className="col-sm-3">
            {I18n.t("pages.installations.view.siret:label")}
          </dt>
          <dd className="col-sm-9">{state.clientInfos.siret}</dd>

          <dt className="col-sm-3">
            {I18n.t("pages.installations.view.vat-number:label")}
          </dt>
          <dd className="col-sm-9">{state.clientInfos.vatCode ?? <NoData />}</dd>
        </dl>
      ) : null}
    </>
  );
}
